import { Anchor, AnchorGroup } from "@/components/anchors-navigation";
import { Element, useEditor, useNode } from "@craftjs/core";
import { useEffect, useState } from "react";
import HomeButton from "./components/HomeButton";
import HomeButtonContainer from "./components/HomeButtonContainer";
import HomeHeading from "./components/HomeHeading";
import HomeMedia from "./components/HomeMedia";
import HomeParagraph from "./components/HomeParagraph";
import { default as HomeTextContainer } from "./components/HomeTextContainer";

interface AnchorData {
    id: string;
    text: string;
    tag?: string;
}

const HomeContent = () => {
    const [anchors, setAnchors] = useState<AnchorData[]>([]);

    const {
        connectors: { connect },
    } = useNode();

    const { nodes, enabled } = useEditor((state) => ({
        nodes: state.nodes,
        enabled: state.options.enabled,
    }));

    useEffect(() => {
        const headings = document.querySelectorAll(".craftjs-heading-anchor");
        const anchors: AnchorData[] = [];

        headings.forEach((heading, index) => {
            const id = "block-" + (index + 1);
            const text = heading.getAttribute("data-anchor-label") || "";
            const tag = heading.getAttribute("data-anchor-tag") || "";

            if (text) {
                heading.id = id; // Set the ID for the heading element
                anchors.push({ id, text, tag });
            }
        });

        setAnchors(anchors);
    }, [nodes]);

    const renderContent = () => {
        return (
            <main className="container relative mx-auto 2xl:px-[108px] z-[1]">
                <div className="relative grid grid-cols-[280px_minmax(100px,_1fr)] gap-14">
                    <div className="absolute -mt-[150px] top-0 left-43 w-full flex justify-center items-center h-full pointer-events-none">
                        <svg
                            width="331"
                            height="2538"
                            viewBox="0 0 331 2538"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                opacity="0.5"
                                d="M126.484 1C182.484 156 306.5 181 297.5 382C286.887 619.014 38.4844 592 5.48441 857C-29.9442 1141.5 325.771 1177.35 297.484 1419C266.113 1687 31.5707 1623 40.5 1944C49.7251 2275.63 366.137 2190 324.137 2537"
                                stroke="#05B692"
                                strokeWidth="5"
                                strokeDasharray="13 13"
                            />
                        </svg>
                    </div>

                    <AnchorGroup>
                        {anchors.map((anchor) => (
                            <Anchor key={anchor.id} id={anchor.id} tag={anchor.tag}>
                                {anchor.text}
                            </Anchor>
                        ))}
                    </AnchorGroup>

                    <div className="py-[160px]">
                        <div className="grid grid-cols-2 grid-rows-[repeat(5,_minmax(280px,max-content))]  gap-x-0 gap-y-[200px]">
                            <div id="block-1" className="flex flex-col gap-6 mb-4 mt-auto">
                                <Element id="heading-1" is={HomeHeading} text="Pourquoi BIMids?" />
                                <Element id="text-1" is={HomeTextContainer} canvas>
                                    <Element
                                        id="text-1-paragraph-1"
                                        is={HomeParagraph}
                                        text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique
                                    at 
                                    <a
                                        href="#"
                                        class="font-bold text-primary-500 hover:text-primary-600 hover:underline"
                                    >
                                        nulla et, imperdiet molestie nibh
                                    </a>.`}
                                    />
                                    <Element
                                        id="text-1-paragraph-2"
                                        is={HomeParagraph}
                                        text={`
                                    Vestibulum mollis viverra odio vitae sodales. Praesent eu pretium purus. Suspendisse
                                    potenti. Pellentesque posuere iaculis tempus.`}
                                    />
                                </Element>

                                <Element id="buttons-1" is={HomeButtonContainer} canvas>
                                    <Element id="button-1" is={HomeButton} text="En savoir plus?" />
                                </Element>
                            </div>

                            <div className="flex items-center justify-end mb-auto">
                                <Element id="image-1" is={HomeMedia} src="/assets/homepage-image-1.png" />
                            </div>

                            <div className="flex items-center justify-start mb-auto">
                                <Element id="image-2" is={HomeMedia} src="/assets/homepage-image-2.png" />
                            </div>

                            <div id="block-2" className="flex flex-col gap-6">
                                <Element id="heading-2" is={HomeHeading} text="Éléments BIM" />
                                <Element id="text-2" is={HomeTextContainer} canvas>
                                    <Element
                                        id="text-2-paragraph-1"
                                        is={HomeParagraph}
                                        text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique
                                    at 
                                    <a
                                        href="#"
                                        class="font-bold text-primary-500 hover:text-primary-600 hover:underline"
                                    >
                                        nulla et, imperdiet molestie nibh
                                    </a>.`}
                                    />
                                    <Element
                                        id="text-2-paragraph-2"
                                        is={HomeParagraph}
                                        text={`
                                    Vestibulum mollis viverra odio vitae sodales. Praesent eu pretium purus. Suspendisse
                                    potenti. Pellentesque posuere iaculis tempus.`}
                                    />
                                </Element>

                                <Element id="buttons-2" is={HomeButtonContainer} canvas>
                                    <Element id="button-1" is={HomeButton} text="Découvrir nos éléments BIM" />
                                </Element>
                            </div>

                            <div id="block-3" className="flex flex-col gap-6 my-auto">
                                <Element id="heading-3" is={HomeHeading} text="Spécifier" anchorTag="1" />
                                <Element id="text-3" is={HomeTextContainer} canvas>
                                    <Element
                                        id="text-3-paragraph-1"
                                        is={HomeParagraph}
                                        text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique
                                    at 
                                    <a
                                        href="#"
                                        class="font-bold text-primary-500 hover:text-primary-600 hover:underline"
                                    >
                                        nulla et, imperdiet molestie nibh
                                    </a>.`}
                                    />
                                    <Element
                                        id="text-3-paragraph-2"
                                        is={HomeParagraph}
                                        text={`
                                    Vestibulum mollis viverra odio vitae sodales. Praesent eu pretium purus. Suspendisse
                                    potenti. Pellentesque posuere iaculis tempus.`}
                                    />
                                </Element>

                                <Element id="buttons-3" is={HomeButtonContainer} canvas>
                                    <Element id="button-1" is={HomeButton} text="Commencer à spécifier!" />
                                </Element>
                            </div>

                            <div className="flex items-center justify-end mb-auto">
                                <Element id="image-3" is={HomeMedia} src="/assets/homepage-image-3.png" />
                            </div>

                            <div className="flex items-center justify-start mb-auto">
                                <Element id="image-4" is={HomeMedia} src="/assets/homepage-image-4.png" />
                            </div>

                            <div id="block-4" className="flex flex-col gap-6 my-auto">
                                <Element id="heading-4" is={HomeHeading} text="Implémenter" anchorTag="2" />
                                <Element id="text-4" is={HomeTextContainer} canvas>
                                    <Element
                                        id="text-4-paragraph-1"
                                        is={HomeParagraph}
                                        text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique
                                    at 
                                    <a
                                        href="#"
                                        class="font-bold text-primary-500 hover:text-primary-600 hover:underline"
                                    >
                                        nulla et, imperdiet molestie nibh
                                    </a>.`}
                                    />
                                    <Element
                                        id="text-4-paragraph-2"
                                        is={HomeParagraph}
                                        text={`
                                    Vestibulum mollis viverra odio vitae sodales. Praesent eu pretium purus. Suspendisse
                                    potenti. Pellentesque posuere iaculis tempus.`}
                                    />
                                </Element>

                                <Element id="buttons-4" is={HomeButtonContainer} canvas>
                                    <Element id="button-1" is={HomeButton} text="Implémentez BimIDS" />
                                </Element>
                            </div>

                            <div id="block-5" className="flex flex-col gap-6 my-auto">
                                <Element id="heading-5" is={HomeHeading} text="Vérifier" anchorTag="3" />
                                <Element id="text-5" is={HomeTextContainer} canvas>
                                    <Element
                                        id="text-5-paragraph-1"
                                        is={HomeParagraph}
                                        text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique
                                    at 
                                    <a
                                        href="#"
                                        class="font-bold text-primary-500 hover:text-primary-600 hover:underline"
                                    >
                                        nulla et, imperdiet molestie nibh
                                    </a>.`}
                                    />
                                    <Element
                                        id="text-5-paragraph-2"
                                        is={HomeParagraph}
                                        text={`
                                    Vestibulum mollis viverra odio vitae sodales. Praesent eu pretium purus. Suspendisse
                                    potenti. Pellentesque posuere iaculis tempus.`}
                                    />
                                </Element>

                                <Element id="buttons-5" is={HomeButtonContainer} canvas>
                                    <Element id="button-1" is={HomeButton} text="Vérifiez vos projets" />
                                </Element>
                            </div>

                            <div className="flex items-center justify-end">
                                <Element id="image-5" is={HomeMedia} src="/assets/homepage-image-5.png" />
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        );
    };

    if (enabled) return <div ref={(ref) => connect(ref!)}>{renderContent()}</div>;

    return renderContent();
};

HomeContent.craft = {
    displayName: "Content",
    rules: {
        canDrag: () => false,
        canMoveOut: () => false,
    },
    custom: {
        canDelete: false,
    },
};

export default HomeContent;
